import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { Dialog, DialogTitle, DialogActions, DialogContent, DialogContentText } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { MdAdd, MdApproval, MdArrowBack, MdArrowRightAlt, MdClass, MdDone, MdEmail, MdInbox, MdMail, MdMarkunreadMailbox, MdOutlineApproval, MdOutlineSettingsSuggest, MdPassword, MdRememberMe, MdResetTv, MdSchool, MdSend, MdSettings, MdSettingsAccessibility } from "react-icons/md";
import { Commet } from "react-loading-indicators";
import { useNavigate } from "react-router-dom";
import { Button } from "rsuite";
import { web_url } from "../../constant";

const url = "http://localhost:8080/api/";
function InviteStudents() {
    const [language, setLanguage] = useState(() => {
        const categoryNow = localStorage.getItem('language') ? localStorage.getItem('language') : 'English';
        return categoryNow;
    })
    const { t, i18n } = useTranslation();
    useEffect(() => {
        switch (language) {
            case 'English':
                i18n.changeLanguage('en');
                break;
            case 'Sinhala':
                i18n.changeLanguage('si');
                break;
            case 'Tamil':
                i18n.changeLanguage('ta');
                break;
            default:
                i18n.changeLanguage('en');
                break;
        }
        localStorage.setItem('language', language);
    }, [language]);
    const navigate = useNavigate();

    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setStudentEmail("")
        setOpen(false);
    };

    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang);
    };


    const [studentEmail, setStudentEmail] = useState('')

    const [error, setError] = useState({
        invalidEmail: false,
        noEmail: false
    })


    const [isLoading, setIsLoading] = useState(false);

    const [openError, setOpenError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');

    const handleClickOpenError = (err) => {
        if (err.toLowerCase().includes('internal server error')) {
            setErrorMsg(t('t93'));
        } else if (err.toLowerCase().includes('the student is already registered')) {
            setErrorMsg(t('t119'));
        } else if (err.toLowerCase().includes('user found already')) {
            setErrorMsg(t('t414'));
        } else if (err.toLowerCase().includes('an invitation has already been sent')) {
            setErrorMsg(t('t120'));
        } else {
            setErrorMsg(t('t94'));
        }
        setIsLoading(false);
        setOpenError(true);
    };

    const handleCloseError = () => {
        setOpenError(false);
        navigate('/teacher/invitestudents')
    };

    const handleButtonClick = () => {

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        let newErrors = {};

        newErrors.noEmail = !studentEmail;

        if ((studentEmail) && !emailRegex.test(studentEmail)) {
            newErrors.invalidEmail = true;
        } else {
            newErrors.invalidEmail = false;
        }

        setError(newErrors);

        if (Object.values(newErrors).some((error) => error)) {
            return;
        }
        // handleClickOpen2();
        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails = getLogDetails();

        const invitation = {
            senderEmail: logDetails.email,
            receiverEmail: studentEmail
        };
        setIsLoading(true);

        const getLogDetails2 = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails2 = getLogDetails2();

        const configToken = {
            headers: {
                'Authorization': `Bearer ${logDetails2.token}`,
            },
        };

        axios.get(`${web_url}/api/auth/students`, configToken)
            .then((response) => {
                if ((response.data).some(record => record.userEmail === studentEmail)) {
                    handleClickOpenError("the student is already registered");
                    setIsLoading(false);
                    setStudentEmail("")
                } else {
                    const filterDataInvCheck = {
                        receiverEmail: studentEmail
                    }

                    const config = {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${logDetails2.token}`,
                        },
                    };

                    axios.post(`${web_url}/api/invitations/admin/filter`, filterDataInvCheck, config).then((resAdminInv) => {
                        let invitationsOtherThanStudent = [];
                        if (resAdminInv.data.length > 0) {
                            invitationsOtherThanStudent = resAdminInv.data.filter((inv) => inv.userRole !== "STUDENT" && inv.invitationStatus === "ACCEPTED");
                        }
                        if (invitationsOtherThanStudent.length > 0) {
                            handleClickOpenError("user found already");
                            setIsLoading(false);
                            setStudentEmail("")
                        } else {
                            axios.get(`${web_url}/api/invitations`, configToken)
                                .then((response) => {
                                    if ((response.data).some(record => (record.studentEmail === studentEmail && record.invitationStatus === "PENDING"))) {
                                        handleClickOpenError("an invitation has already been sent");
                                        setStudentEmail("")
                                    } else {
                                        const apiUrl = `${url}invitations`;
                                        const config = {
                                            headers: {
                                                'Content-Type': 'application/json',
                                                'Authorization': `Bearer ${logDetails2.token}`,
                                            },
                                        };
                                        // axios.post(apiUrl, invitation, config)
                                        axios.post(`${web_url}/api/invitations`, invitation, config)
                                            .then((response) => {
                                                // console.log("API Response:", response.data);
                                                setStudentEmail("")
                                                setOpen(true)
                                                setIsLoading(false);
                                            })
                                            .catch((err) => {
                                                // console.log("error occured1", err);
                                                setStudentEmail("")
                                                if (err.response) {
                                                    // console.log(err.response)
                                                    if (err.response.data.error) {
                                                        handleClickOpenError(err.response.data.error);
                                                    } else if (err.response.data.message) {
                                                        handleClickOpenError(err.response.data.message);
                                                    } if (err.response.data.token) {
                                                        handleClickOpenError(err.response.data.token);
                                                    } else {
                                                        handleClickOpenError("An unknown error occured");
                                                    }

                                                }
                                                setIsLoading(false);
                                            })
                                    }
                                })
                                .catch((err1) => {
                                    setStudentEmail("")
                                    if (err1.response) {
                                        // console.log(err1.response)
                                        if (err1.response.data.error) {
                                            handleClickOpenError(err1.response.data.error);
                                        } else if (err1.response.data.message) {
                                            handleClickOpenError(err1.response.data.message);
                                        } if (err1.response.data.token) {
                                            handleClickOpenError(err1.response.data.token);
                                        } else {
                                            handleClickOpenError("An unknown error occured");
                                        }

                                    }
                                });
                        }
                    }).catch((errAdminInv) => {
                        setStudentEmail("")
                        if (errAdminInv.response) {
                            // console.log(err1.response)
                            if (errAdminInv.response.data.error) {
                                handleClickOpenError(errAdminInv.response.data.error);
                            } else if (errAdminInv.response.data.message) {
                                handleClickOpenError(errAdminInv.response.data.message);
                            } if (errAdminInv.response.data.token) {
                                handleClickOpenError(errAdminInv.response.data.token);
                            } else {
                                handleClickOpenError("An unknown error occured");
                            }

                        }
                    })

                }
            })
            .catch((err) => {
                setStudentEmail("")
                handleClickOpenError('error occured');
            });
    }


    return (
        <>
            <div className={`${i18n.language === "en" ? "font-urban" : (i18n.language === "si" ? "font-noto" : "font-mukta")}  w-screen xl:pt-[20px]`}>
                <div className="pt-[100px] md:pt-[130px] lg:pt-[150px] xl:pt-[0px] w-full">
                    <div className="ml-[30px] md:ml-[60px] lg:ml-[80px] xl:ml-[80px] w-full flex justify-start flex items-center">
                        <MdArrowBack size={25} className="md:hidden" onClick={() => {
                            navigate('/teacher/managestudents')
                        }} />
                        <MdArrowBack size={30} className="hidden md:block xl:hidden" onClick={() => {
                            navigate('/teacher/managestudents')
                        }} />
                        <MdArrowBack size={30} className="hidden xl:block" onClick={() => {
                            navigate('/teacher/managestudents')
                        }} />
                        <p className="text-[20px] md:text-[23px] lg:text-[25px] xl:text-[20px] 2xl:text-[22px] font-bold px-[10px] py-[5px] md:px-[13px] md:py-[8px]">{t('t111')}</p>
                    </div>
                </div>

                <div className="flex justify-center mt-[40px]">
                    <img src="/images/add_student.svg" alt="add students" />
                </div>
                <div className="ml-[20px] mr-[20px] md:ml-[100px] md:mr-[100px] lg:ml-[250px] lg:mr-[250px] xl:ml-[400px] xl:mr-[400px] 2xl:ml-[600px] 2xl:mr-[600px] items-center mt-[20px] flex rounded-md bg-[#F1F6FB] px-[10px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-300 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                    <MdEmail size="24px" color="#8189B0" />
                    <input type="text" value={studentEmail} name="email" className="ml-[10px] w-full bg-[#F1F6FB] text-[15px] md:text-[17px] lg:text-[18px] text-gray-900 placeholder:text-[#8189B0] focus:outline focus:outline-0" placeholder={t('t115')}
                        onChange={(e) => {
                            setStudentEmail(e.target.value.toLowerCase())
                        }}
                    />
                </div>

                {error.noEmail &&
                    <p className='ml-[20px] mr-[20px] md:ml-[100px] md:mr-[100px] lg:ml-[250px] lg:mr-[250px] xl:ml-[400px] xl:mr-[400px] 2xl:ml-[600px] 2xl:mr-[600px] text-[#ff0000] text-[12px] mt-[5px]'>{t('t15')}</p>
                }
                {error.invalidEmail &&
                    <p className='ml-[20px] mr-[20px] md:ml-[100px] md:mr-[100px] lg:ml-[250px] lg:mr-[250px] xl:ml-[400px] xl:mr-[400px] 2xl:ml-[600px] 2xl:mr-[600px] text-[#ff0000] text-[12px] mt-[5px]'>{t('t16')}</p>
                }

                <div className="flex justify-center px-[30px] md:px-[0px]">
                    <button onClick={handleButtonClick} disabled={isLoading} className="text-[18px] mt-[20px] rounded-lg pt-[10px] pb-[10px] w-[400px] hover:bg-opacity-80 bg-gradient-to-r from-[#FFA803] to-[#FFD12E] ">
                        {isLoading ? (
                            <div className="items-center justify-center flex">
                                <div className='w-5 h-5 border-2 border-t-transparent border-white rounded-full animate-spin'></div>
                            </div>
                        ) : (
                            t('t116')
                        )}
                    </button>
                </div>

            </div>

            <Dialog
                open={open}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm "
            >
                <DialogContent className="bg-[#FFF6DA]">
                    {!isLoading &&
                        <DialogContent
                            id="custom-dialog-description"
                            className="text-gray-600 text-md mt-2"
                        >
                            <div className='flex flex-col justify-center items-center text-center'>
                                <img src='/images/success.svg' alt='success' />
                                <div className='mt-[30px]'>{t('t117')}</div>
                                <Button
                                    onClick={handleClose}
                                    className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md mt-[10px]"
                                    style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                                >
                                    Close
                                </Button>
                            </div>
                        </DialogContent>
                    }

                </DialogContent>
            </Dialog>

            <Dialog
                open={openError}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleCloseError(); // Allow closing only for other reasons
                    }
                }}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >
                <DialogTitle
                    id="custom-dialog-title"
                    className="text-2xl font-bold text-gray-800 border-b border-gray-300 pb-2"
                >
                    {t('t95')}
                </DialogTitle>
                <DialogContent className="bg-gray-50">
                    <DialogContentText
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        {errorMsg}
                    </DialogContentText>
                </DialogContent>
                <DialogActions className="px-4 py-2">
                    <Button
                        onClick={handleCloseError}
                        className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                        style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                    >
                        {t('t96')}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default InviteStudents;
